import React, { useContext, useState, useEffect, useRef } from 'react'
import './HomeNavLinks.css'
import { NavLink, Link } from 'react-router-dom'
import { AuthContext } from '../../context/auth-context'
//import NavLinksHomeDropdown from '../../../admin/components/NavLinksHomeDropdown'

const HomeNavLinks = (props) => {
	//const [isHomeMenuDropDownOpen, setHomeMenuDropDownOpen] = useState(false)
	const auth = useContext(AuthContext)
	const propsString = props.leagueId

	let page

	if (auth.isLoggedIn) {
		//console.log('User is logged in!')
		page = '/admin/leagues/current'
	} else {
		//console.log('User is NOT logged in!')
		page = '/admin/login'
	}
	//
	//
	//****************************************************************************** */
	//
	//  Home dropdown menu stuff
	//
	//
	//****************************************************************************** */
	/* const closeHoverHomeMenu = () => {
		setHomeMenuDropDownOpen(false)
	}
	const homeDropdownRef = useRef(null)
	useHomeOnHoverOutside(homeDropdownRef, closeHoverHomeMenu) // Call the hook

	function useHomeOnHoverOutside(ref, handler) {
		useEffect(() => {
			const listener = (event) => {
				if (!ref.current || ref.current.contains(event.target)) {
					return
				}
				handler(event)
			}
			document.addEventListener('mouseover', listener)
			return () => {
				document.removeEventListener('mouseout', listener)
			}
		}, [ref, handler])
	} */

	return (
		<ul className='home-nav-links'>
			{/* <li>
				<a href='https://murrysvillesportzone.com/'>HOME</a>
			</li> */}
			{/* <li>
				<div ref={homeDropdownRef}>
					<NavLink
						to='#'
						id='homeButton'
						onMouseOver={() => setHomeMenuDropDownOpen(true)} //use mouseover event to show dropdown
						// style={{ border: 'none', background: '#92562e' }}
					>
						HOME
					</NavLink>
					{isHomeMenuDropDownOpen && <NavLinksHomeDropdown />}
				</div>
			</li> */}
			<li>
				<NavLink to={`https://nsbhl.com/`}>NSBHL HOME</NavLink>
			</li>
			{props.leagueId && (
				<li>
					<NavLink to={`/league/schedule/${propsString}`}>SCHEDULE</NavLink>
				</li>
			)}
			{!props.leagueId && (
				<li>
					<NavLink to={'/schedule'}>SCHEDULE</NavLink>
				</li>
			)}

			{props.leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/league/${propsString}`}>STANDINGS</NavLink>
				</li>
			)}
			{!props.leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={'/statsandstandings'}>STANDINGS</NavLink>
				</li>
			)}

			<li>
				<NavLink to={'/playerStats'}>PLAYER PAGES</NavLink>
			</li>

			<li>
				<NavLink to={page}>ADMIN</NavLink>
			</li>
		</ul>
	)
}

export default HomeNavLinks
